import { CONST } from '@/utils/constants'

const reportBaseUrl = (userId) => `${CONST.Services.BaseURLs.API}/users/${userId}/reports`

export const reportUrls = {
  getReport: (userId, start, count, refresh) => `${reportBaseUrl(userId)}/data?start=${start}&count=${count}&refresh=${refresh}`,
  saveSession: (userId, managerId) => `${reportBaseUrl(userId)}/${managerId}/saveSession`,
  switchModes: (userId, managerId) => `${reportBaseUrl(userId)}/${managerId}/switchModes`
}

export const dataEntryUrls = {
  trySetValue: (userId, managerId, rowIndex, columnIndex) => `${reportBaseUrl(userId)}/${managerId}/trySetValue?rowIndex=${rowIndex}&columnIndex=${columnIndex}`,
  insertRow: (userId, managerId, rowIndex) => `${reportBaseUrl(userId)}/${managerId}/insertNewRow?rowIndex=${rowIndex}`,
  clearCells: (userId, managerId) => `${reportBaseUrl(userId)}/${managerId}/clearCells`
}

export const metadataUrls = {
  metadata: () => `${CONST.Services.BaseURLs.API}/metadata`
}

export const userUrls = {
  login: () => `${CONST.Services.BaseURLs.App}/login-gateway`,
  logout: () => `${CONST.Services.BaseURLs.API}/Logout`,
  current: () => `${CONST.Services.BaseURLs.API}/users/current`,
  getUser: (id) => `${CONST.Services.BaseURLs.API}/users/${id}`
}

export const groupUrls = {
  getGroup: (id) => `${CONST.Services.BaseURLs.API}/groups/${id}`
}

export const discussionUrls = {
  getDiscussion: (id) => `${CONST.Services.BaseURLs.API}/discussions/${id}`
}

export const workspaceUrls = {
  getViewList: () => `${CONST.Services.BaseURLs.API}/search?categories=Grid,Chart,Metric&max=2000&excludedTags=&sort=Name`,
  newWorkspaceReq: (userId) => `${CONST.Services.BaseURLs.API}/users/${userId}/workspaces`,
  addVisualizationToWorkspace: (userId, workspaceId, pageId) => `${CONST.Services.BaseURLs.API}/users/${userId}/workspaces/${workspaceId}/pages/${pageId}?open=false`,
  getWorkspace: (userId, workspaceId) => `${CONST.Services.BaseURLs.API}/users/${userId}/workspaces/${workspaceId}?open=false`,
  getAllWorkspaces: (userId, max=20) => `${CONST.Services.BaseURLs.API}/users/${userId}/workspaces/?max=${max}`
}

export const distributionUrls = {
  getDistribution: (id) => `${CONST.Services.BaseURLs.API}/approval_workflows/${id}`
}

export const visualizationUrls = {
  getVisualization: (id) => `${CONST.Services.BaseURLs.API}/visualizations/${id}`
}

export const alertUrls = {
  getAlert: (userId, id) => `${CONST.Services.BaseURLs.API}/users/${userId}/userobjects/trigger/${id}`
}

export const searchUrls = {
  getSearchResults: (filters={}) => {
    if (Object.keys(filters).length > 0) {
      //build key/value pairs and create the final api request url
      filters.categories = filters.categories.join('%2C')
      for(let [key, value] of Object.entries(filters)) {
        if (`${value}`.length > 0) filters[key] = `&${key}=${value}`
      }
      let { categories, query, start, max, groupBy, excludedTags, age, startDate, endDate, sort, selectedUser } = filters    
      return `${CONST.Services.BaseURLs.API}/search?${categories.substring(1)}${query}${start}${max}${groupBy}${excludedTags}${age}${startDate}${endDate}${sort}${selectedUser}`
    }
  }
}

export default {
  metadataUrls,
  reportUrls,
  dataEntryUrls,
  userUrls,
  groupUrls,
  discussionUrls,
  workspaceUrls,
  distributionUrls,
  visualizationUrls,
  alertUrls,
  searchUrls
}
